import { type Countries } from '@ctct/domain-layer';

import type { TranslationGetter } from '../../../../types';

export class CountriesService {
  constructor(private countries: Countries, private t: TranslationGetter) {}

  public api() {
    return {};
  }

  public data() {
    return {
      getCountries: () =>
        this.countries.getCountries().map((country) => ({
          text: country.display,
          key: country.code,
          value: country.code,
        })),

      getCountryName: (countryCode: string) => this.countries.getCountryLabel(countryCode),

      getStates: (selectedCountryCode?: string) => {
        if (!selectedCountryCode) return [];

        return this.countries.getStates(selectedCountryCode).map((state) => ({
          text: state.display,
          key: state.code,
          value: state.code,
        }));
      },

      getStateLabel: (selectedCountryCode?: string) => {
        if (!selectedCountryCode) return undefined;

        return this.countries.getStateLabel(selectedCountryCode);
      },

      getStatePlaceholder: (selectedCountryCode?: string) => {
        return this.countryHasProvinces(selectedCountryCode)
          ? this.t('application-layer.billing-info-base.select-province')
          : this.t('application-layer.billing-info-base.select-state');
      },

      isShowingStates: (selectedCountryCode?: string) => {
        if (!selectedCountryCode) return false;

        return this.countries.isShowingStates(selectedCountryCode);
      },

      isShowingTaxAgreement: (selectedCountryCode?: string) => {
        if (!selectedCountryCode) return false;

        return this.countries.isShowingTaxAgreement(selectedCountryCode);
      },

      isShowingTaxNumber: (selectedCountryCode?: string) => {
        if (!selectedCountryCode) return false;

        return this.countries.isShowingTaxNumber(selectedCountryCode);
      },

      getTaxDisclaimer: (selectedCountryCode?: string) => {
        if (!selectedCountryCode) return '';

        return this.countries.getTaxDisclaimer(selectedCountryCode) ?? '';
      },

      getTaxLabel: (selectedCountryCode?: string) => {
        if (!selectedCountryCode) return '';

        return this.countries.getTaxLabel(selectedCountryCode) ?? '';
      },

      countryHasProvinces: (selectedCountryCode?: string) => this.countryHasProvinces(selectedCountryCode),
    };
  }

  public handlers() {
    return {};
  }

  private countryHasProvinces(selectedCountryCode?: string) {
    if (!selectedCountryCode) return false;

    return this.countries.getCountryHasProvinces(selectedCountryCode);
  }
}
